import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import toIndianCurrency from 'utils/ToIndianCurrencyFormat.js';
import checkboxImage from 'assets/icons/Checkbox.svg';
import checkedImage from 'assets/icons/checkedicon.svg';

const limeRow = {
  background: '#FFF3BE',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: '5px',
  borderRadius: '5px',
  justifyContent: 'flex-start',
  marginBottom: '10px',
};

const rowInlineStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  paddingLeft: '10px',
  paddingRight: '10px',
};
const lavenderRow = {
  background: '#D7E0FF',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: '5px',
  borderRadius: '5px',
  justifyContent: 'flex-start',
  marginBottom: '10px',
};

const paidBy = {
  fontSize: '12px',
  marginLeft: '10px',
  marginBottom: '0px',
  color: 'black',
};
const displayFlex = { display: 'flex', alignItems: 'center' };

const OtherExpenses = ({ classes, indentDetails }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <GridContainer className={classes.customMargin}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.noPadding}
            style={{
              float: 'left',
              textAlign: 'left',
              paddingLeft: '0px !important',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                color: 'black',
                fontWeight: '400',
                margin: '10px 0px',
              }}
            >
              Other Expenses{' '}
              <span style={{ fontSize: '12px', fontStyle: 'italic' }}>
                (Transporter)
              </span>
            </h3>
          </GridItem>
          <GridItem className={classes.noPadding} xs={12} sm={12} md={12}>
            <GridContainer spacing={2}>
              <GridItem xs={6} md={4}>
                <div style={limeRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Loading Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.loading_charges_transporter
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.loading_charges_paid_by_transporter ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          width: '16px',
                        }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.loading_charges_paid_by_transporter
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Transporter
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={limeRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Hamali Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.hamali_charges_transporter
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.hamali_charges_paid_by_transporter ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          width: '16px',
                        }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.hamali_charges_paid_by_transporter
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Transporter
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={limeRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Halting Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.halting_charges_transporter
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.halting_charges_paid_by_transporter ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{ marginLeft: '10px', width: '16px' }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.halting_charges_paid_by_transporter
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Transporter
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={limeRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">
                      Unloading Halting Charges
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.unloading_halting_charges_transporter
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.unloading_halting_charges_paid_by_transporter ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{ marginLeft: '10px', width: '16px' }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.unloading_halting_charges_paid_by_transporter
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Transporter
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={limeRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Unloading Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.unloading_charges_transporter
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.unloading_charges_paid_by_transporter ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.unloading_charges_paid_by_transporter
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Transporter
                    </p>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </Grid>

      <Grid item xs={12}>
        <GridContainer className={classes.customMargin}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.noPadding}
            style={{
              float: 'left',
              textAlign: 'left',
              paddingLeft: '0px !important',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                color: 'black',
                fontWeight: '400',
                margin: '10px 0px',
              }}
            >
              Other Expenses{' '}
              <span style={{ fontSize: '12px', fontStyle: 'italic' }}>
                (Trucker)
              </span>
            </h3>
            <p style={{ color: 'red', fontSize: '12px' }}>
              (If the Box is not ticked, the expense is paid by Lobb.)
            </p>
          </GridItem>
          <GridItem className={classes.noPadding} xs={12} sm={12} md={12}>
            <GridContainer spacing={2}>
              <GridItem xs={6} md={4}>
                <div style={lavenderRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Loading Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(indentDetails?.loading_charges_trucker)}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.loading_charges_paid_by_trucker ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{ marginLeft: '10px', width: '16px' }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.loading_charges_paid_by_trucker
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Trucker
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={lavenderRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Hamali Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(indentDetails?.hamali_charges_trucker)}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.hamali_charges_paid_by_trucker ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{ marginLeft: '10px', width: '16px' }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.hamali_charges_paid_by_trucker
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Trucker
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={lavenderRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Halting Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(indentDetails?.halting_charges_trucker)}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.halting_charges_paid_by_trucker ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.halting_charges_paid_by_trucker
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Trucker
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={lavenderRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">
                      Unloading Halting Charges
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.unloading_halting_charges_trucker
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.unloading_halting_charges_paid_by_trucker ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',
                          marginRight: '5px',
                          width: '16px',
                        }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.unloading_halting_charges_paid_by_trucker
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Trucker
                    </p>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={lavenderRow}>
                  <div style={rowInlineStyle}>
                    <Typography variant="body1">Unloading Charges</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        color: 'black',
                      }}
                    >
                      {toIndianCurrency(
                        indentDetails?.unloading_charges_trucker
                      )}
                    </Typography>
                  </div>
                  <div style={displayFlex}>
                    {indentDetails?.unloading_charges_paid_by_trucker ? (
                      <img
                        src={checkedImage}
                        alt="icon"
                        style={{
                          marginLeft: '10px',

                          width: '16px',
                        }}
                      />
                    ) : (
                      <img
                        src={checkboxImage}
                        alt="icon"
                        style={{ marginLeft: '10px', width: '16px' }}
                      />
                    )}

                    <p
                      style={{
                        fontWeight: indentDetails?.unloading_charges_paid_by_trucker
                          ? 'bold'
                          : '',
                        ...paidBy,
                      }}
                    >
                      Paid By Trucker
                    </p>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </Grid>
    </Grid>
  );
};

export default OtherExpenses;
